/* src/app/order/components/decline-order-button/decline-order-button.style.scss */
.decline-order-modal {
  padding: 6% 12%;
  width: 680px;
}
.decline-order-modal nb-card-body {
  padding: 0 !important;
  margin-bottom: 10px;
}
.decline-order-modal #declined-order-info {
  margin: 3% 0 46px;
}
.decline-order-modal label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  display: block;
  margin-bottom: 5px;
}
.decline-order-modal nb-card-footer {
  border: none;
  padding: 0 0 1rem 0;
  display: flex;
  justify-content: flex-end;
}
.decline-order-modal nb-card-footer button:nth-child(2) {
  margin-left: 20px;
}
@media screen and (max-width: 991px) {
  .decline-order-modal {
    padding: 20px 30px;
    margin-bottom: 0;
  }
  .decline-order-modal h2 {
    margin-top: 0;
  }
}
@media screen and (max-width: 767px) {
  .decline-order-modal {
    width: 80%;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
  .decline-order-modal h2 {
    font-size: 1.2rem;
    line-height: 1.6rem;
  }
}
@media screen and (max-width: 767px) and (orientation: landscape) {
  .decline-order-modal #declined-order-info {
    margin-bottom: 20px;
  }
  .decline-order-modal h2 {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 479px) {
  .decline-order-modal {
    max-width: 400px;
  }
  .decline-order-modal h2 {
    font-size: 1.4rem;
    line-height: 2rem;
  }
}
/*# sourceMappingURL=decline-order-button.style.css.map */
